import type {
  AgentApiParams,
  ConnectionMetrics,
} from 'src/types/scheduler/global';
import type {Dispatch, ThunkAction} from 'src/reducers';

import {camel} from 'src/utils';
import * as reduxApi from 'src/utils/redux-api-v2';


export const SET_AGENT_API_PARAMS = 'scheduling/global/setAgentApiParams';
export const SET_CONNECTION_METRICS = 'scheduling/global/setConnectionMetrics';

// action types
export type SchedulerGlobalActions =
  | SetAgentApiParamsAction
  | SetConnectionMetricsAction;

// set agent api params action
export type SetAgentApiParamsAction = {
  type: typeof SET_AGENT_API_PARAMS;
  payload: AgentApiParams;
};
export const setAgentApiParams = (
  payload: AgentApiParams,
): SetAgentApiParamsAction => ({
  type: SET_AGENT_API_PARAMS,
  payload,
});

// set connection metrics action
export type SetConnectionMetricsAction = {
  type: typeof SET_CONNECTION_METRICS;
  payload: ConnectionMetrics;
};
export const setConnectionMetrics = (
  payload: ConnectionMetrics,
): SetConnectionMetricsAction => ({
  type: SET_CONNECTION_METRICS,
  payload,
});

export const fetchConnectionMetrics =
  (): ThunkAction => async (dispatch: Dispatch) => {
    try {
      const res = await dispatch(
        reduxApi.get('scheduler/accounts/connections'),
      );

      dispatch(setConnectionMetrics(camel(res)));
    } catch (err: any) {
      throw err;
    }
  };
